import url from './url';
import locale from './locale';
import modules from './modules';
import sysRole from './role';

export default {
  url,
  locale,
  modules,
  sysRole,
};



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/configs/index.js
 **/